import { render, staticRenderFns } from "./MainSettingsEditAdmin.vue?vue&type=template&id=3c1f5f3e&scoped=true"
import script from "./MainSettingsEditAdmin.vue?vue&type=script&lang=js"
export * from "./MainSettingsEditAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1f5f3e",
  null
  
)

export default component.exports